import { Directive } from '@angular/core';
import { Product } from '@df/catalog/product/product';
import { GtmImpressionTrackDirectiveDef } from '@df/module-gtm/gtm-impression-track.directive.def';
import { Gtm } from '@df/module-gtm/gtm.namespace';

@Directive({
    selector: '[gtmImpressionTrack]',
    standalone: true
})
export class GtmImpressionTrackDirective extends GtmImpressionTrackDirectiveDef {
    override updateImpression(product: Product | undefined, impression: Gtm.ITrackImpressionData): void {
        const productImpression = this.gtmService.toProductData(product);
        if (productImpression && !this.sent) {
            productImpression.position = impression.position;
            productImpression.numberOfResults = impression.numberOfResults;
            productImpression.list = impression.list || this.gtmService.getDefaultListName();
            this.gtmService.trackImpressionsBuffered([productImpression]);
            this.sent = true;
        }
    }
}
